import React from "react";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import Service from "../MenAboutus/Service";
import WhyChoose from "../MenAboutus/WhyChoose";
import Faq from "../MenAboutus/Faq";
import Footer from "../Global/Footer";
import GoToTop from "../Global/GoToTop";
import Call from "../Menhomeone/Call";
import Experts from "../MenAboutus/Experts";

const Main = () => {
  return (
    <>
      <Preloader />
      <Header />
      <BredCrumb Title="Jasa Kami" subtitle="Jasa Kami" />
      {/* <div className="page_wrapper"> */}
      <Experts />
      <Faq />
      <Call />
      <Footer />
      <GoToTop />
      {/* </div> */}
    </>
  );
};

export default Main;
